// extracted by mini-css-extract-plugin
module.exports = {"links":"Privacy_links__3neph","list":"Privacy_list__OFOWX","link":"Privacy_link__3b5-j","container":"Privacy_container__AZzZy","checkbox":"Privacy_checkbox__2ov8u"};